import { ACTIONS } from "./../constants"


const initialState = { 
  integrationSessions: [], 
  integrationSession: {}, 
  appointments: [],
  appointment: {},
  appointmentInitvalues: null,
  skillsEvaluation: {},
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: {
    isDeactivated: false,
    isDeleted: false,
    isActivated: false,
    isCreated: false,
    isUpdated: false,
  },
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_INTEGRATION_SESSION : {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.SET_APPOINTMENT_INIT_VALUE: {
      return { ...state, appointmentInitvalues: payload }
    }

    case ACTIONS.FETCH_INTEGRATION_SESSIONS_INIT : {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_INTEGRATION_SESSIONS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, integrationSessions: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_INTEGRATION_SESSIONS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_INTEGRATION_SESSION_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_INTEGRATION_SESSION_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, appointmentInitvalues: null, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_INTEGRATION_SESSION_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.EDIT_INTEGRATION_SESSION_INIT : {      
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_INTEGRATION_SESSION_SUCCEDED : {
      return { ...state, success: { ...state.success, isUpdated: true }, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_INTEGRATION_SESSION_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }
 
    case ACTIONS.FETCH_INTEGRATION_SESSION_INIT : {
      return { ...state, isLoading: true, integrationSession: null, error: null }
    }
    case ACTIONS.FETCH_INTEGRATION_SESSION_SUCCEDED : {
      return { ...state, integrationSession: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_INTEGRATION_SESSION_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DISABLE_INTEGRATION_SESSION_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DISABLE_INTEGRATION_SESSION_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeactivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_INTEGRATION_SESSION_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DELETE_INTEGRATION_SESSION_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_INTEGRATION_SESSION_SUCCEDED: {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_INTEGRATION_SESSION_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ENABLE_INTEGRATION_SESSION_INIT: {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.ENABLE_INTEGRATION_SESSION_SUCCEDED: {
      return { ...state, success: { ...state.success, isActivated: true }, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_INTEGRATION_SESSION_FAILED: {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.FETCH_APPOINTMENTS_INIT: {
      return { ...state, isFetching: true, appointments: [], error: null }
    }
    case ACTIONS.FETCH_APPOINTMENTS_SUCCEDED: {
      return { ...state, appointments: payload, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_APPOINTMENTS_FAILED: {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.EDIT_INTEGRATION_SESSION_APPOINTMENT_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_INTEGRATION_SESSION_APPOINTMENT_SUCCEDED : {
      let appointments = []
      if (payload.isCanceled){
        appointments = state.appointments.filter((appointment) => appointment.id === payload.id )
      }else {
        appointments = state.appointments.map((appointment) => appointment.id !== payload.id ? ({ ...appointment }) : ({ ...payload}) )
      }
      return { ...state, appointment: payload, success: { ...state.success, isUpdated: true }, appointments, isLoading: false, error: null }    
    }
    case ACTIONS.EDIT_INTEGRATION_SESSION_APPOINTMENT_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }

    case ACTIONS.FETCH_INTEGRATION_SESSION_APPOINTMENT_INIT : {
      return { ...state, isLoading: true, appointment: null, error: null }
    }
    case ACTIONS.FETCH_INTEGRATION_SESSION_APPOINTMENT_SUCCEDED : {
      return { ...state, appointment: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_INTEGRATION_SESSION_APPOINTMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.CREATE_INTEGRATION_SESSION_APPOINTMENT_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_INTEGRATION_SESSION_APPOINTMENT_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, appointment: payload, appointments: [...(state.appointments || []), payload ], isLoading: false }
    }
    case ACTIONS.CREATE_INTEGRATION_SESSION_APPOINTMENT_FAILED : {
      return { ...state, error: payload, isLoading: false }
    }

    default: {
      return state
    }
  }
}
